import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_USD } from '../data/checkout';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label = `YES! I want the HYROX Coach Blueprint — $${PRICE_USD}`,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'The HYROX Coach Blueprint',
    content_ids: ['hyrox-coach-blueprint'],
    content_type: 'product',
    value: PRICE_USD,
    currency: 'USD'
  })} className={`group inline-flex items-center justify-center gap-3 rounded-sm bg-volt font-display font-bold uppercase tracking-wide text-ink transition-[transform,background-color] duration-150 ease-swift hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-volt active:translate-y-px ${size === 'lg' ? 'px-8 py-5 text-2xl sm:text-3xl' : 'px-6 py-3.5 text-lg sm:text-xl'} ${className}`} data-id="element-37" data-mp="qjs9le76x577">
      <ShoppingCartIcon className={size === 'lg' ? 'h-6 w-6 shrink-0' : 'h-5 w-5 shrink-0'} aria-hidden="true" data-id="element-38" data-mp="39z1656nqg9rc" />
      <span className="text-center leading-none" data-id="element-39" data-mp="3ezx7bcgp9ht2">{label}</span>
    </a>;
}